import { userLogData, userVisitData } from '@/sdk/collect/types';

type toBackEndData = userVisitData | userVisitData[] | userLogData | userLogData[];

export function reportUserVisitAction(data: userVisitData | userVisitData[]): void {
    try {
        report('/api/core/process/cockpit/collect/userBehavior', data);
    } catch (_) {
        //
    }
}

export function reportLog(data: userLogData | userLogData[]): void {
    try {
        report('/api/core/process/log/push', data);
    } catch (_) {
        //
    }
}

function report(url: string, data: toBackEndData): void {
    // 尽量不影响页面主线程
    if (window.requestIdleCallback) {
        window.requestIdleCallback(() => {
            sendInfo(url, data);
        });
    } else {
        sendInfo(url, data);
    }
}

function sendInfo(url: string, data: toBackEndData) {
    try {
        if (!navigator.sendBeacon) {
            const headers = {
                type: 'application/json',
                token: window.localStorage.ISC_SSO_TOKEN as string
            };
            const blob = new window.Blob([JSON.stringify(data)], headers);
            navigator.sendBeacon(url, blob);
        } else if ('fetch' in window) {
            try {
                void fetch(url, {
                    method: 'POST',
                    body: JSON.stringify(data),
                    headers: {
                        'content-type': 'application/json',
                        connection: 'keep-alive',
                        token: window.localStorage.ISC_SSO_TOKEN as string
                    },
                    mode: 'cors'
                });
            } catch (e) {
                console.error(e);
            }
        } else {
            const xhr = new XMLHttpRequest();
            xhr.open('POST', url, true);
            xhr.setRequestHeader('Content-Type', 'application/json');
            xhr.setRequestHeader('token', window.localStorage.ISC_SSO_TOKEN);
            xhr.send(JSON.stringify(data));
        }
    } catch (error) {
        console.log('发送消息出错：', error);
    }
}
